import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { ReactComponent as TableHeaderFilterIcon } from "../../assets/svg/TableHeaderFilterIcon.svg";
import { SvgIcon } from "@material-ui/core";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { generateElementIdentifier } from "utils/ApplicationUtils";
import { DATA_IDENTIFIER, ELEMENT } from "../App/app-constant";

const CustomDateRangePickerPopUp = ({ classes, handleFilterPopupOpen, anchorName = "", isSingleDatePicker, handleDateChangeEvent, handleCancel, value }) => {
  const dateRangeRef = useRef(null);

  useEffect(() => {
    if (dateRangeRef.current) {
      dateRangeRef.current.setStartDate(value?.startDate || new Date());
      dateRangeRef.current.setEndDate(value?.endDate || new Date());
    }
  }, [value]);

  return (
    <DateRangePicker
      key={anchorName}
      name={anchorName}
      onApply={handleDateChangeEvent}
      onCancel={handleCancel}
      initialSettings={{
        singleDatePicker: isSingleDatePicker,
        cancelButtonClasses: "btn-primary",
        locale: { format: "YYYY-MM-DD", cancelLabel: "Reset" },
      }}
      ref={dateRangeRef}
    >
      <SvgIcon data-testid={generateElementIdentifier({ key: DATA_IDENTIFIER.DATE_RANGE_PICKER, customKey:anchorName, element: ELEMENT.SVG_ICON })} key={anchorName} className={classes.rootIcon} component={TableHeaderFilterIcon} onClick={handleFilterPopupOpen} />
    </DateRangePicker>
  );
};

CustomDateRangePickerPopUp.propTypes = {
  classes: PropTypes.object.isRequired,
  handleFilterPopupOpen: PropTypes.func.isRequired,
  anchorName: PropTypes.string,
  isSingleDatePicker: PropTypes.bool,
  handleDateChangeEvent: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  value: PropTypes.shape({
    startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  }),
};

export default CustomDateRangePickerPopUp;
